// extracted by mini-css-extract-plugin
export default {"root":"jIkU2","transform":"OVk_c","swipeable":"_2kag6","preview":"_3c2dl","next":"R-Dwu","prev":"_3Ko1d"};